// =============================================================================
//  PREÇOS E CONFIGURAÇÕES DO SITE
//  Este é o único arquivo que precisa ser editado para mudar valores,
//  ligar o seletor de idioma ou passar a mostrar os preços em dólar.
// =============================================================================

export const CONFIG = {
  // Mostra os botões PT / EN no topo do site.
  // Deixe false para o site ficar só em português.
  mostrarSeletorDeIdioma: false,

  // Moeda usada em cada idioma.
  // Para mostrar dólar quando o site estiver em inglês, troque 'BRL' por 'USD'
  // na linha do "en" — os valores abaixo continuam em reais, a conversão é
  // feita automaticamente pela cotação.
  moedaPorIdioma: {
    pt: "BRL",
    en: "USD",
  },

  // Quantos reais valem 1 dólar. Só é usado se alguma moeda acima for 'USD'.
  cotacaoDoDolar: 5.4,
};

// -----------------------------------------------------------------------------
//  Como escrever cada item:
//
//    nome   → o texto do serviço (chave de tradução, veja src/locales/*.json)
//    preco  → o valor EM REAIS, só o número (ex.: 210)
//    nota   → linha pequena embaixo, opcional
//    mais   → true mostra "+ R$ 25,00" (adicional somado a outro serviço)
//    apartirDe → true mostra "a partir de R$ 15,00"
//    cada   → true mostra "R$ 20,00 cada"
// -----------------------------------------------------------------------------

export const FIBRA_DE_VIDRO = {
  aplicacao: [
    {
      nome: "fibraVidro.application",
      preco: 210,
      nota: "fibraVidro.application.included",
    },
    {
      nome: "fibraVidro.application.nailBiting",
      preco: 230,
      nota: "fibraVidro.application.included",
    },
    {
      nome: "fibraVidro.application.newApplication",
      preco: 260,
      nota: "fibraVidro.application.included",
    },
    {
      nome: "fibraVidro.removal",
      preco: 80,
      nota: "fibraVidro.removal.noCuticle",
    },
    {
      nome: "service.gelPolishApplication",
      preco: 25,
      mais: true,
    },
  ],

  manutencao: [
    { nome: "fibraVidro.maintenance.upTo30", preco: 145 },
    { nome: "fibraVidro.maintenance.after30", preco: 165 },
    { nome: "fibraVidro.maintenance.after40", preco: 190 },
    { nome: "maintenanceFromAnotherProfessional", preco: 180 },
    { nome: "service.gelPolishMaintenance", preco: 25, mais: true },
  ],

  adicionais: [
    { nome: "fibraVidro.additionals.whiteGel", preco: 25 },
    { nome: "fibraVidro.additionals.nailReplacement", preco: 10 },
    { nome: "fibraVidro.additionals.encapsulatedUnit", preco: 8 },
    { nome: "fibraVidro.additionals.decoration", preco: 15, apartirDe: true },
    { nome: "formatChange", preco: 10 },
    { nome: "service.brokenNailRepair", preco: 20, cada: true },
  ],
};

export const BANHO_DE_GEL = {
  aplicacao: [
    { nome: "gel.application", preco: 170, nota: "gel.application.included" },
    {
      nome: "gel.newApplication",
      preco: 200,
      nota: "gel.application.included",
    },
    { nome: "gel.removal", preco: 80, nota: "gel.removal.noCuticle" },
    { nome: "service.gelPolishApplication", preco: 25, mais: true },
  ],

  manutencao: [
    { nome: "gel.maintenance.upTo30", preco: 145 },
    { nome: "gel.maintenance.after30", preco: 165 },
    { nome: "gel.maintenance.after40", preco: 190 },
    { nome: "maintenanceFromAnotherProfessional", preco: 180 },
    { nome: "service.gelPolishMaintenance", preco: 25, mais: true },
  ],

  adicionais: [
    { nome: "gel.additionals.whiteGel", preco: 25 },
    { nome: "gel.additionals.nailReplacement", preco: 10 },
    { nome: "gel.additionals.encapsulatedUnit", preco: 8 },
    { nome: "gel.additionals.decoration", preco: 15, apartirDe: true },
    { nome: "formatChange", preco: 10 },
    { nome: "service.brokenNailRepair", preco: 20, cada: true },
  ],

  babyBoomer: [
    {
      nome: "gel.application",
      preco: 220,
      nota: "gel.application.careIncluded",
    },
    {
      nome: "gel.maintenance.upTo30",
      preco: 185,
      nota: "gel.application.careIncluded",
    },
  ],
};
